const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api/v1'
  : 'http://localhost:3000/api/v1';

/**
 * Helper function to handle API responses
 */
async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Bir hata oluştu');
  }
  return response.json();
}

export const api = {
  /**
   * Get leaderboard for a specific city
   * @param {number} cityId 
   * @param {string} username (optional)
   */
  getLeaderboard: async (cityId, username) => {
    let url = `${API_BASE_URL}/leaderboard?city_id=${cityId}`;
    if (username) {
      url += `&username=${username}`;
    }
    const response = await fetch(url);
    return handleResponse(response);
  },

  /**
   * Get the last winner
   */
  getWinner: async () => {
    const response = await fetch(`${API_BASE_URL}/leaderboard/winner`);
    return handleResponse(response);
  },

  /**
   * Start a new game session
   * @param {number} cityId 
   * @param {string} userId (optional)
   */
  startSession: async (cityId, userId) => {
    const response = await fetch(`${API_BASE_URL}/session/start`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ city_id: cityId, user_id: userId }),
    });
    return handleResponse(response);
  },

  /**
   * End a game session and submit score
   * @param {string} sessionId 
   * @param {number} score 
   * @param {number} cityId 
   * @param {string} displayName 
   * @param {number} sessionDuration (milliseconds)
   * @param {string} userId (optional)
   */
  endSession: async (sessionId, score, cityId, displayName, sessionDuration, userId) => {
    const response = await fetch(`${API_BASE_URL}/session/end`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        total_score: score,
        city_id: cityId,
        display_name: displayName,
        session_duration: sessionDuration,
        user_id: userId
      }),
    });
    return handleResponse(response);
  }
};
